import React from "react";
import Icon from "../../shared/components/icon";
import Layout from "../../shared/components/layout";

function AccessDenied() {
  return (
    <Layout banner={"Transfer Health Information"} header={"Access Denied"}>
      <Icon type="chevron-left" size={10} />{" "}
      <span>Your identity could not be confirmed.</span>
    </Layout>
  );
}

export default AccessDenied;
